export type UtilityBoxConfig = {
  utilityBoxType: 'firePanel' | 'electricPanel' | 'controlPanel' | 'dewtectSensor'
  width: number
  height: number
  thickness?: number
  centerPointHeight: number
  color: number
  label: string
  canMountOnColumn: boolean
}

export const firePanel: UtilityBoxConfig = {
  label: 'Fire Panel',
  utilityBoxType: 'firePanel',
  width: 36,
  height: 48,
  centerPointHeight: 72,
  color: 0xff0000,
  canMountOnColumn: false,
}

export const electricPanel: UtilityBoxConfig = {
  label: 'Electric Panel',
  utilityBoxType: 'electricPanel',
  width: 36,
  height: 48,
  centerPointHeight: 72,
  color: 0x0000ff,
  canMountOnColumn: true,
}

export const controlPanel: UtilityBoxConfig = {
  label: 'Control Panel',
  utilityBoxType: 'controlPanel',
  width: 18,
  height: 18,
  centerPointHeight: 72,
  color: 0x000000,
  canMountOnColumn: true,
}

export const dewtectSensor: UtilityBoxConfig = {
  label: 'Dewtect Sensor',
  utilityBoxType: 'dewtectSensor',
  width: 12,
  height: 16,
  centerPointHeight: 72,
  color: 0xbab86c,
  canMountOnColumn: true,
}
